<script setup lang="ts">
import type { NovaBottomTabBar } from '#components'
import { ROUTES } from '@configs'

const route = useRoute()
// const { isApp } = useAppStore()
const layoutStore = useLayoutStore()
const { responsive, bottomTabBarRect } = storeToRefs(layoutStore)
const showBottomTabBar = computed(() => {
  const routeName = String(route.name)

  // 1. 콜백 페이지에서 노출 X
  if (routeName.includes('callback-')) {
    return false
  }

  // 2. 인앱 일때 챗봇 페이지에서 가상 키보드가 올라오면 노출 X
  if (routeName.includes(ROUTES.CHATBOT.name)) {
    return false
  }

  switch (responsive.value) {
    case 'mobile':
      return true
    case 'tablet':
    case 'desktop':
    default:
      return false
  }
})

const updateResponsive = () => {
  const responsive = useGetResponsive()
  layoutStore.updateResponsive(responsive)
}

onMounted(() => {
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    layoutStore.updateTouchDevice(true)
  }
  updateResponsive()
  window.addEventListener('resize', updateResponsive)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateResponsive)
})
</script>

<template>
  <div
    class="wrapper"
    :style="{
      paddingBottom: `${bottomTabBarRect?.height || 0}px`,
    }"
  >
    <slot />
    <NovaBottomTabBar v-if="showBottomTabBar" />
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  background-color: $color-neutral-light-4;
  width: 100%;
  /*overflow-x: hidden;*/
}
</style>
